import React, { createContext, Fragment, useContext, useEffect, useState } from "react";
import FrontOfficeNavbar from "./../../components/navbars/FrontOfficeNavbar";
import LoginAndRegister from "./LoginAndRegister";
import { BasicContext } from "../../App";
import NoPermission from "../../components/NoPermission";
import FrontOfficeModal from "../../components/modals/FrontOfficeModal";
import { postMethod } from "../../requests";
import UserProfile from "../UserProfile";
import Schedule from "./../schedule/Schedule";
import PassesList from "./passes/PassesList";
import ClassesAndPasses from "./ClassesAndPasses";
import SignUpForClass from "../schedule/SignUpForClass";
import SignUpForWaitingList from "../schedule/SignUpForWaitingList";
import PaymentsList from "./PaymentsList";
import ReservationsList from "../reservations/ReservationsList";
import UseReservation from "../reservations/UseReservation";
export const FrontOfficeContext = createContext();

const FrontOffice = () => {
    const { isLogged, noPermission, fetchMainData, showView, checkServerData, setShowView } = useContext(BasicContext);
    const [showFrontOfficeModal, setShowFrontOfficeModal] = useState(false);
    const [settings, setSettings] = useState(null);

    const getGlobalSettings = async () => {
        const res = await postMethod("get-global-settings");
        if (checkServerData(res)) setSettings(res.data.settings);
    };

    useEffect(() => {
        if (settings) setShowFrontOfficeModal(true);
        // eslint-disable-next-line
    }, [settings]);

    useEffect(() => {
        fetchMainData();

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (showView) {
            const main = document.getElementById("main"),
                footerMain = document.getElementById("footerMain").offsetHeight;
            main.style.minHeight = `${window.innerHeight - footerMain - 61}px`;
        }
        // eslint-disable-next-line
    }, [showView]);

    useEffect(() => {
        if (isLogged) {
            setShowView({ nav: "schedule", params: { moduleName: "APP" } });
            getGlobalSettings();
        }
        // eslint-disable-next-line
    }, [isLogged]);

    return (
        <FrontOfficeContext.Provider value={{ settings }}>
            <Fragment>
                {isLogged !== null && noPermission ? (
                    <NoPermission />
                ) : isLogged === false ? (
                    <LoginAndRegister />
                ) : isLogged ? (
                    <Fragment>
                        {showView && (
                            <>
                                <FrontOfficeNavbar />
                                <main id="main">
                                    {showView.nav === "schedule" && (
                                        <>
                                            {showView.sub === "signUpForClass" ? (
                                                <SignUpForClass />
                                            ) : showView.sub === "signUpForWaitingList" ? (
                                                <SignUpForWaitingList />
                                            ) : (
                                                <Schedule />
                                            )}
                                        </>
                                    )}
                                    {showView.nav === "classesAndPasses" && <ClassesAndPasses />}
                                    {showView.nav === "passes" && <>{showView.sub === "passesList" && <PassesList />}</>}
                                    {showView.nav === "userProfile" && <UserProfile />}
                                    {showView.nav === "paymentsList" && <PaymentsList />}
                                    {showView.nav === "reservations" && (
                                        <>
                                            {showView.sub === "reservationsList" && <ReservationsList />}
                                            {showView.sub === "useReservation" && <UseReservation />}
                                        </>
                                    )}
                                </main>
                            </>
                        )}
                    </Fragment>
                ) : null}

                {showFrontOfficeModal && isLogged && !localStorage.getItem("basicInfo") && (
                    <FrontOfficeModal
                        onClose={() => setShowFrontOfficeModal(false)}
                        onProceed={() => {
                            localStorage.setItem("basicInfo", true);
                            setShowFrontOfficeModal(false);
                        }}
                        cancellationWindow={settings.filter((e) => e.setting_code === "CANCELLATION_WINDOW")[0].setting_value_int}
                    />
                )}
            </Fragment>
        </FrontOfficeContext.Provider>
    );
};

export default FrontOffice;
